export default __webpack_public_path__ + "static/O0224-3851d4364773a879b3d804ff0fe5c2a4.png";